import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=381111aa&scoped=true"
import script from "./Builder.vue?vue&type=script&lang=ts"
export * from "./Builder.vue?vue&type=script&lang=ts"
import style0 from "./Builder.vue?vue&type=style&index=0&id=381111aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381111aa",
  null
  
)

export default component.exports